import ConfirmationDialog from "@/shared/components/domain/confirmation/confirmation-dialog";
import {
  useErrArtefactNotReady,
  useSetErrArtefactNotReadyFromRtk,
} from "@/shared/service-manager/artefact/err-artefact-not-ready";
import { Button } from "@/shared/components/ui/button";
import { ReactElement } from "react";
import { Trash } from "lucide-react";
import { useDeleteMouldMutation } from "@/services/backend/mould/service";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";

interface DeleteMouldButtonProps {
  mouldId: string;
}

export default function DeleteMouldButton({
  mouldId,
}: DeleteMouldButtonProps): ReactElement {
  const [deleteMould, { error, reset, isLoading }] = useDeleteMouldMutation();
  const { resetNotReadyError } = useErrArtefactNotReady();
  useSetErrArtefactNotReadyFromRtk(error, () => {
    reset();
  });
  const onConfirm = () => {
    if (isLoading) {
      return;
    }

    resetNotReadyError();
    deleteMould({
      id: mouldId,
    });
  };

  return (
    <>
      <RTKQueryErrorAlert error={error} />
      <ConfirmationDialog
        trigger={
          <Button className="bg-red-600">
            <Trash />
          </Button>
        }
        title="Schimmelpilz löschen"
        description="Hiermit wird der Schimmelpilz aus den Stammdaten gelöscht. Der Schimmelpilz bleibt jedoch bei Prozessen erhalten!"
        onConfirm={onConfirm}
      />
    </>
  );
}
